<div class="integration-chip"
     [class.loading]="loading()"
     [class.connected]="!loading() && status()?.connected"
     [class.disconnected]="!loading() && !status()?.connected"
     (click)="onConnectClick()"
     [attr.aria-label]="status()?.connected ? 'Conectado a ' + providerLabel() : 'Conectar ' + providerLabel()"
     role="button"
     tabindex="0">

  <span class="chip-dot" [class.pulse-dot]="loading()"></span>

  <ng-container *ngIf="loading()">
    <span class="chip-text">COMPROBANDO…</span>
  </ng-container>

  <ng-container *ngIf="!loading() && status()?.connected as s">
    <span class="chip-text">
      CONECTADO A {{ providerLabel().toUpperCase() }}
      <span class="chip-account" *ngIf="status()?.accountName">— {{ status()?.accountName }}</span>
    </span>
    <button type="button"
            class="chip-disconnect"
            (click)="onDisconnectClick($event)"
            aria-label="Desconectar">
      <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true">
        <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    </button>
  </ng-container>

  <ng-container *ngIf="!loading() && !status()?.connected">
    <span class="chip-text">CONECTAR {{ providerLabel().toUpperCase() }}</span>
    <svg class="chip-arrow" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
      <path fill="currentColor" d="M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/>
    </svg>
  </ng-container>
</div>

<p class="chip-error" *ngIf="errorMessage()">{{ errorMessage() }}</p>
